import React, { useEffect, useState } from "react";
import { Spinner, NoDataFound } from "@public/ui-toolkit";
import { Button, CardWithLable, Table } from "@public/ui-toolkit";
import { useHistory } from "react-router";
import PDFPreview from "../../../ui-toolkit/src/PDFPreview/index";
import moment from "moment";
import VideoIframe from "../VideoIframe";
import { Space, Avatar } from "antd";
// const data1 = [{ option: "Strategy" }];
// const data2 = [{ option: "Risk Profile" }];
// const data3 = [{ option: "AUM" }];
// const data4 = [{ option: "Region" }];
// const data5 = [{ option: "By Name" }];
// const data6 = [{ option: "Alpha" }];

const recentChatColumn = [
  {
    name: "Name",
    key: "roomName",
    renderContent: (item) => {
      return (
        <Space size={2}>
          <Avatar src={item.profileImage} /> {item.roomName}
        </Space>
      )
    }
  },
  { 
    name: "Message",
    key: "body",
    renderContent: (item) => {
      return (
        <>
        {item.body != null ? item.body?.includes("<style>") ? "Meeting Invitation" : item?.body?.substring(0, 60) + "....." : "File Sent"}
        </>
      )
    }
   },
];

const fundColumn = [
  { name: "Name", key: "name" },
  { name: "Strategy", key: "strategyTitle" },
  { name: "Monthly Returns", key: "monthlyReturn", toFixed: 2 },
];

const NewsFeedComponent = ({
  loading,
  getPosts,
  type = true,
  editDeleteIcon = false,
  deleteMyPosts,
  getRecentChat,
  fundWatchList,
  showWatchList = false,
  showButton = true
}) => {
  const [filterPosts, setFilterPosts] = useState();
  const history = useHistory();

  useEffect(() => {
    if (getPosts?.items) {
      const listItem = getPosts?.items;
      setFilterPosts(listItem);
    }
  }, [getPosts?.items]);

  const deletePosts = (id) => {
    const newList = filterPosts?.filter((item) => item.id !== id);
    deleteMyPosts(id);
    setFilterPosts(newList);
  };

  return (
    <main>
      <div className={showButton ? `main-inner` : ""}>
        <div className="container">
          {showButton ? (

            <div
              className="
            main-content-header
            p-4
            d-flex
            flex-wrap
            justify-content-end
            align-items-center
          "
            >

              <Button
                btnName="Create Post"
                btnType="primary"
                onClick={() => history.push("/createpost")}
              />
            </div>
          ) : ("")}
          <div className="row g-3">
            {type ? (
              <div className="col-lg-6 col-xl-4 mb-lg-0 mb-4">
                {showWatchList === true ? (
                  <CardWithLable
                    title="Fund Watch List"
                    img="./assets/images/drag-icon.svg"
                    alt="drag icon"
                    cardSpacing="primary"
                  >
                    <div className="hf-card2-body px-0 pb-0">
                      <div className="hf-table table-responsive">
                        <Table columns={fundColumn} data={fundWatchList} />
                      </div>
                    </div>
                  </CardWithLable>
                ) : (
                  ""
                )}
                <CardWithLable
                  title="Recent Chat"
                  img="./assets/images/drag-icon.svg"
                  alt="drag icon"
                  cardSpacing="primary"
                >
                  <div className="hf-card2-body px-0 pb-0">
                    <div className="hf-table">
                      <Table columns={recentChatColumn} data={getRecentChat} />
                    </div>
                  </div>
                  <div className="hf-card2-footer">
                    <div className="text-right">
                      <a href="/chat" className="text-berylline text-mini">
                        <u>View More</u>
                      </a>
                    </div>
                  </div>
                </CardWithLable>
              </div>
            ) : (
              ""
            )}
            <div
              className={type ? "col-lg-6 col-xl-8" : "col-lg-12 col-xl-12"}
              style={{ height: "70vh", overflowY: "scroll" }}
              id="newsfeedScroll"
            >
              {filterPosts?.length ? (
                filterPosts?.map((d, index) => {
                  return (
                    <div className="single-newsfeed mb-3" key={index}>
                      <div className="author-info">
                        <div className="author-avatar">
                          <img
                            src={"/assets/images/favIcon.png"}
                            alt="avatar"
                          />
                        </div>
                        <div className="author-detail">
                          <div className="d-flex justify-content-between">
                            {" "}
                            <h5 className="author-name">
                              {d.userFullName}
                            </h5>{" "}
                            <span className="ml-3">{d.userTitle}</span>{" "}
                            {editDeleteIcon === true ? (
                              <div className="dropdown">
                                <i
                                  style={{ fontSize: "24px" }}
                                  className="fa"
                                  type="button"
                                  id="dropdownMenu2"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  &#xf142;
                                </i>

                                <div
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenu2"
                                >
                                  <button
                                    className="dropdown-item"
                                    type="button"
                                    onClick={() =>
                                      history.push(`/updatepost/:${d?.id}`)
                                    }
                                  >
                                    <i
                                      className="fa fa-edit"
                                      style={{ fontSize: "16px" }}
                                    >
                                      <span
                                        className="ml-1"
                                        style={{ fontSize: "16px" }}
                                      >
                                        Edit
                                      </span>
                                    </i>
                                  </button>
                                  <button
                                    className="dropdown-item"
                                    type="button"
                                    onClick={() => deletePosts(d.id)}
                                  >
                                    <i
                                      className="fa fa-trash-o"
                                      style={{ fontSize: "16px" }}
                                    >
                                      <span
                                        className="ml-1"
                                        style={{ fontSize: "16px" }}
                                      >
                                        Delete
                                      </span>
                                    </i>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <p className="author-address">{d?.tenantName}</p>
                        </div>
                      </div>

                      <div className="single-newsfeed-body">
                        <div className="sn-body-content">
                          <p dangerouslySetInnerHTML={{ __html: d.description }}></p>
                        </div>
                        <div className="ml-3">
                          <div
                            id={`carouselExampleControls${d.id}`}
                            className="carousel slide"
                            data-bs-ride={`carousel${d.id}`}
                          >
                            <div className="carousel-inner">
                              {d.records
                                ? d.records.map((item, index) => {
                                    const fileType = item?.type?.split("/");
                                    return (
                                      <>
                                        {fileType[0] === "image" ? (
                                          <div
                                            className={`carousel-item ${
                                              index === 0 ? " active" : ""
                                            }`}
                                          >
                                            <div
                                              data-bs-toggle={"modal"}
                                              data-bs-target={`#video-pop${item.id}`}
                                              key={item?.url}
                                            >
                                              <img
                                                src={item?.url}
                                                className="d-block w-100"
                                                alt="..."
                                              />
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {fileType[1] === "pdf" ? (
                                          <>
                                            <div
                                              className={`carousel-item ${
                                                index === 0 ? " active" : ""
                                              }`}
                                            >
                                              <div
                                                data-bs-toggle={"modal"}
                                                data-bs-target={`#video-pop${item.id}`}
                                                key={item?.url}
                                              >
                                                <PDFPreview
                                                  src={item && item?.url}
                                                  className="d-block w-100"
                                                  title="pdf-preview"
                                                />
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          ""
                                        )}

                                        {fileType[1] === "mp4" ? (
                                          <>
                                            <div
                                              className={`carousel-item ${
                                                index === index + 1
                                                  ? " active"
                                                  : ""
                                              }`}
                                            >
                                              <div
                                                data-bs-toggle={"modal"}
                                                data-bs-target={`#video-pop${item.id}`}
                                                key={item?.url}
                                              >
                                                <video
                                                  width="400"
                                                  className="d-block w-100"
                                                  controls
                                                >
                                                  <source
                                                    src={item?.url}
                                                    type="video/mp4"
                                                    width="auto"
                                                  />
                                                  Your browser does not support
                                                  HTML video.
                                                </video>
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    );
                                  })
                                : "No Activity Found"}
                            </div>
                            <div>
                              {d?.records?.length > 1 && (
                                <>
                                  <button
                                    className="carousel-control-prev"
                                    type="button"
                                    data-bs-target={`#carouselExampleControls${d.id}`}
                                    data-bs-slide="prev"
                                  >
                                    <span
                                      className="carousel-control-prev-icon carousel-icon-bg"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="visually-hidden">
                                      Previous
                                    </span>
                                  </button>
                                  <button
                                    className="carousel-control-next"
                                    type="button"
                                    data-bs-target={`#carouselExampleControls${d.id}`}
                                    data-bs-slide="next"
                                  >
                                    <span
                                      className="carousel-control-next-icon carousel-icon-bg"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="visually-hidden">
                                      Next
                                    </span>
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="newsfeed-date p-3">
                          <p className="mb-0">
                            {d.postedDate}
                            <span className="text-blue">
                              {moment(
                                [d.creationTime],
                                "YYYY-MM-DDhh:mm:ss"
                              ).format("MMM DD YYYY hh:mm:ss a")}{" "}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="d-flex justify-content-center">
                  <NoDataFound message="No Activity Found!" />
                </div>
              )}
              {loading && (
                <>
                  <Spinner className="text-center" />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <VideoIframe newsFeedDetails={getPosts?.items} />
      </div>
    </main>
  );
};

export default NewsFeedComponent;
